package app.smartcoding.realrate.presentation.util

import kotlin.math.round

fun Double.toCleanString(): String {
    val s = round(this * 100).toLong().toString().padStart(3, '0')
    val integralPart = s.dropLast(2)
    val fractionPart = s.takeLast(2).takeIf { it.toInt() != 0 }?.let { ".$it" } ?: ""
    return integralPart + fractionPart
}